export const LOADING_STATUSES = {
  failed: "failed",
  loading: "loading",
  promptReviewLoading: "prompt-review-loading",
  setIntentLoading: "set-intent-loading",
  success: "success",
};
